// extracted by mini-css-extract-plugin
export default {"Container":"EditSpan_Container__RxIvj","Icon":"EditSpan_Icon__0WaHo"};